import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { SUBSCRIPTION_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_STRIPE_SUBSCRIPTION: undefined,
    API: {
      GET_STRIPE_SUBSCRIPTION: apiResourceActionCreator('stripeSubscription'),
    },
  },
});

export const apiAction = (authToken) => commonApiActions.authenticated.get(SUBSCRIPTION_ENDPOINT, authToken, actions.payment.api.getStripeSubscription);

export function* fetchSubscription(_) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
};

const configuration = {
  name: 'getStripeSubscription',
  action: actions,
  sagas: fetchSubscription,
  reducers: {
    request: (state, _) => ({
      ...state,
      isFetching: true,
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      stripeSubscription: action.payload.stripeSubscription,
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error,
    }),
  },
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getStripeSubscription.js